import { EMPTY_STRING } from './constants';

function InvalidMetricsProvider(metricsProviderName = EMPTY_STRING) {
  return new Error(`Error: ${metricsProviderName} is not initialized`);
}

export default InvalidMetricsProvider;
